module.exports = "https://static.zego.com/_next/static/images/NewProducts-eebbf7e28dc348bca1e8487accc3f7d1.svg";